import data from '../sample/data';

function AboutPage() {
  const skills = [
    { name: 'ReactJS', level: 85 },
    { name: 'TailwindCSS', level: 85 },
    { name: 'PHP', level: 75 },
    { name: 'MySQL', level: 70 },
    { name: 'JavaScript', level: 80 },
  ];

  return (
    <div className="grid md:grid-cols-2 gap-10 items-start">
      <div className="space-y-4">
        <h2 className="text-2xl font-semibold">About Me</h2>
        <p className="text-foreground/80">I am a Computer Science and Information Technology graduate from <b>Mehendra Multiple Campus</b>, with strong skills in <b>software development, web technologies, and system analysis</b>. Passionate about creating solutions that merge functionality with creativity.</p>
        <div className="rounded-2xl p-1 bg-white/10 border border-white/10 inline-block hover:shadow-glass transition-transform hover:-translate-y-0.5">
          <img alt="profile" src={data.profile.avatar} className="w-40 h-40 rounded-2xl object-cover" />
        </div>
        <ul className="list-disc pl-5 text-sm text-foreground/80 space-y-1">
          {data.highlights.map((h, idx) => (<li key={idx}>{h}</li>))}
        </ul>
      </div>
      <div className="space-y-4">
        <h3 className="font-medium">Skills</h3>
        <div className="space-y-3">
          {skills.map((s) => (
            <div key={s.name}>
              <div className="flex justify-between text-sm"><span>{s.name}</span><span>{s.level}%</span></div>
              <div className="h-2 rounded bg-white/10">
                <div className="h-full rounded bg-primary" style={{ width: `${s.level}%` }} />
              </div>
            </div>
          ))}
        </div>
        <div className="pt-4 space-y-3">
          <div>
            <h4 className="text-sm font-medium mb-2">Frontend</h4>
            <div className="flex flex-wrap gap-2">
              {data.skills.frontend.map((s) => (
                <span key={s} className="px-2 py-1 rounded-full bg-white/10 text-xs">{s}</span>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-sm font-medium mb-2">Backend</h4>
            <div className="flex flex-wrap gap-2">
              {data.skills.backend.map((s) => (
                <span key={s} className="px-2 py-1 rounded-full bg-white/10 text-xs">{s}</span>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-sm font-medium mb-2">Tools</h4>
            <div className="flex flex-wrap gap-2">
              {data.skills.tools.map((s) => (
                <span key={s} className="px-2 py-1 rounded-full bg-white/10 text-xs">{s}</span>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-sm font-medium mb-2">Concepts</h4>
            <div className="flex flex-wrap gap-2">
              {data.skills.concepts.map((s) => (
                <span key={s} className="px-2 py-1 rounded-full bg-white/10 text-xs">{s}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;


